import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';
import { useReveal } from '../../hooks/useReveal';

export default function About() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.07 });

  return (
    <section
      ref={ref}
      id="sobre"
      className="section"
      style={{ background: 'var(--p2a-dark-bg)', borderBottom: '1px solid var(--p2a-dark-border)' }}
    >
      <div className="p2-container about-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1.3fr', gap: 80, alignItems: 'start' }}>
        <div>
          <div className="eyebrow reveal" style={{ marginBottom: 20 }}>
            <span className="dot" />{t('home.about.eyebrow')}
          </div>
          <h2 className="h-1 reveal">{t('home.about.title')}</h2>
        </div>
        <div>
          <p className="reveal" style={{ fontSize: 18, lineHeight: 1.6, color: 'var(--p2a-dark-fg-2)', marginBottom: 24 }}>
            {t('home.about.p1')}
          </p>
          <p className="reveal" style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--p2a-dark-fg-3)', marginBottom: 24 }}>
            {t('home.about.p2_1')}
            <strong style={{ color: 'var(--p2a-dark-fg-1)', fontWeight: 600 }}>{t('home.about.p2_strong1')}</strong>
            {t('home.about.p2_2')}
            <strong style={{ color: 'var(--p2a-dark-fg-1)', fontWeight: 600 }}>{t('home.about.p2_strong2')}</strong>
            {t('home.about.p2_3')}
          </p>
          <div className="reveal" style={{ display: 'flex', gap: 12, marginTop: 32, flexWrap: 'wrap' }}>
            <a
              href="https://api.whatsapp.com/send?phone=5519996542014&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20a%20equipe%20da%20Pix2Agro."
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              {t('home.about.cta_primary')} <Icon.ArrowRight />
            </a>
            <a href="https://youtube.com/@pix2agro902" target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
              <Icon.Play width={12} height={12} /> {t('home.about.cta_secondary')}
            </a>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 820px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
      `}</style>
    </section>
  );
}
